// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"36":"52033bc78d6ae2bd","184":"8a48b7a9205de903","385":"32486836a2713b80","453":"8ceb7c821cfb99c4","883":"d84ac721b5b78418"}[chunkId] + ".js";
};